import { render, staticRenderFns } from "./ownInfo.vue?vue&type=template&id=29367624&"
import script from "./ownInfo.vue?vue&type=script&lang=js&"
export * from "./ownInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports